import gql from 'graphql-tag';

export const refreshTask = gql`
  subscription refreshTask($room_id: ID) {
    refreshTask(room_id: $room_id)
  }
`;
